import { PartyUidSchema } from '@lotta/shared/types-lottery-schemas';
import type { Static } from '@sinclair/typebox';
import { Type } from '@sinclair/typebox';

export type NewManualParticipant = Static<typeof NewManualParticipantSchema>;
export const NewManualParticipantSchema = Type.Object(
  {
    // The id is set by react-hook-form
    id: Type.Optional(Type.String({ format: 'uuid' })),
    partyUid: PartyUidSchema,
    entryDate: Type.String({ format: 'date' }),
  },
  { additionalProperties: false, $id: 'NewManualParticipantSchema' }
);

export type FormData = Static<typeof FormDataSchema>;
export const FormDataSchema = Type.Object(
  {
    newParticipants: Type.Array(NewManualParticipantSchema, { minItems: 1, maxItems: 1000 }),
  },
  { additionalProperties: false, $id: 'FormDataSchema' }
);
